import { BreachEvent } from '@news-mono/web-common'
import React from 'react'
import { MessageBannerSmall } from '../../../../../banners/MessageBannerSmall/MessageBannerSmall'
import TW1000PromoBanner from '../../../../../banners/TW1000Promo/TW1000PromoBanner'
import { VideoTrailerCard } from '../../../../../cards/VideoTrailerCard/VideoTrailerCard'
import { packageOfferDetails } from '../../../common'
import BreachWallContent from './BreachWallContent/BreachWallContent'
import {
    StyledABTestBannerWrap,
    StyledLiveTrailerWrap,
    StyledMessage,
    StyledTerms,
    StyledTitle,
} from './BreachWallContent/BreachWallContent.styled'
import { BreachWallContentType, BreachWallStyle } from '../../../helpers/BreachWallTypes'
import { AbTestExperiment, getStoredExperiment } from '../../../abtesting/AbTestingProvider'
import { useLocation } from 'react-router'

export interface BreachNotificationProps {
    breachCreativeName: string
    breachDeal: string
    onEvent: (event: BreachEvent) => void
    type: BreachWallContentType
    // Optional properties that can be passed on a per-campaign basis
    contentOptions?: {
        [key: string]: any
    }
}

export function BreachNotification({
    breachDeal,
    breachCreativeName,
    onEvent,
    contentOptions,
    type,
}: BreachNotificationProps) {
    const experiment = getStoredExperiment(useLocation())
    const variant = experiment?.getVariantFromType(type)

    const shouldShowLiveSportsTrailer =
        contentOptions && contentOptions.showLiveSportTrailer

    const showBanner = contentOptions && contentOptions.showBanner

    const breach190Year = breachDeal === '190BD23'
    const breach190YearStyle = breach190Year ? 'breach-190-year' : 'breachwall'

    const breachMatildas = type === 'matildas-offer'

    const is50percentOffDeal =
        breachDeal === 'COVIDDIG' ||
        breachDeal === 'GOVAN50' ||
        breachDeal === 'AFL50'

    const is30percentOffDeal =
        breachDeal === 'BIKEDI30' || breachDeal === 'SCHOOL30'

    const isAbTest = experiment !== undefined
    const subscriptionPackages = packageOfferDetails(type)

    return (
        <div data-testid="BreachScreen">
            <MessageBannerSmall icon="subscriber" onEvent={onEvent}>
                <p>Subscribers with digital access can view this article.</p>
            </MessageBannerSmall>

            <BreachWallContent
                breachCreativeName={breachCreativeName}
                breachDeal={breachDeal}
                breachType={type}
                onEvent={onEvent}
                title={() => {
                    if (is50percentOffDeal) {
                        return (
                            <React.Fragment>
                                {breachDeal === 'AFL50' ? (
                                    <StyledTitle>
                                        Footy Pack Discount – 50% off for a
                                        limited time
                                    </StyledTitle>
                                ) : (
                                    <StyledTitle>Limited Offer</StyledTitle>
                                )}
                                <StyledMessage>
                                    {breachDeal !== 'AFL50' && (
                                        <p>Save over 50% for 8 weeks*</p>
                                    )}
                                    {breachDeal === 'AFL50' && (
                                        <p>
                                            Don't miss a single story this footy
                                            season. From WAFL to AFL, we've got
                                            you covered.
                                        </p>
                                    )}
                                </StyledMessage>
                            </React.Fragment>
                        )
                    }
                    if (is30percentOffDeal) {
                        return (
                            <React.Fragment>
                                <StyledTitle>Limited Time Offer</StyledTitle>
                                <StyledMessage>
                                    {breachDeal === 'SCHOOL30' && (
                                        <p>
                                            Subscribe now to save 30%* and view
                                            WA’s REAL Top 50 Schools plus get
                                            24/7 access to breaking news direct
                                            to your device
                                        </p>
                                    )}
                                    {breachDeal === 'BIKEDI30' && (
                                        <p>
                                            Subscribe now to save 30%* and enjoy
                                            unlimited access to investigative
                                            video series, breaking news, sport,
                                            business and lifestyle direct to
                                            your device
                                        </p>
                                    )}
                                </StyledMessage>
                            </React.Fragment>
                        )
                    }
                    if (isAbTest) {
                        const breachStyle: BreachWallStyle = experiment !== undefined ? experiment?.getBreachStyle(variant || 0) : 'default-breachwall'
                        return getAbTestTitle(breachStyle, experiment, variant || 0);
                    }
                    if (breachMatildas) {
                        return (
                            <React.Fragment>
                                <StyledABTestBannerWrap
                                    breachStyle={
                                        breachMatildas ? 'aussie' : undefined
                                    }
                                >
                                    <StyledMessage>
                                        <StyledTitle>SCORE 50% OFF</StyledTitle>
                                        <p className="full-width">
                                            Everyday Digital for 8 weeks
                                        </p>
                                        <p className="abtest-terms">
                                            T's & C's apply
                                        </p>
                                    </StyledMessage>
                                </StyledABTestBannerWrap>
                            </React.Fragment>
                        )
                    }

                    return (
                        <React.Fragment>
                            <StyledTitle>Subscribe today.</StyledTitle>
                            <StyledMessage>
                                <p>
                                    Unlimited access to breaking news, sport,
                                    business, lifestyle and in-depth exclusives
                                    home delivered or direct to your device.
                                </p>
                            </StyledMessage>
                        </React.Fragment>
                    )
                }}
                terms={() => {
                    if (is50percentOffDeal || is30percentOffDeal) {
                        return (
                            <StyledTerms>
                                *Valid for new subscribers only.
                                {` ${breachDealTerms(breachDeal)}`}
                                <br />
                                T&Cs apply
                            </StyledTerms>
                        )
                    }

                    return null
                }}
                mediaBanner={() => {
                    if (shouldShowLiveSportsTrailer) {
                        return (
                            <StyledLiveTrailerWrap>
                                <VideoTrailerCard
                                    layoutMode="double"
                                    onEvent={() => null}
                                />
                            </StyledLiveTrailerWrap>
                        )
                    }
                    if (showBanner && breach190Year) {
                        return (
                            <TW1000PromoBanner
                                imageOnly={true}
                                breachDeal={breachDeal}
                            />
                        )
                    }
                    return null
                }}
                subscriptionPackages={subscriptionPackages}
            />
        </div>
    )
}

function breachDealTerms(deal: string) {
    switch (deal) {
        case 'SCHOOL30':
            return 'Offer ends 23 November 2022.'
        case 'BIKEDI30':
            return 'Offer ends 21 November 2022.'
        case 'GOVAN50':
            return 'Offer ends 20 February 2021.'
        case 'BRE1DISC':
            return 'Offer ends 2 May 2021.'
        default:
            return ''
    }
}

export function getAbTestTitle(style: BreachWallStyle, experiment: AbTestExperiment, variant: number): JSX.Element {
    const bannerLayout = experiment.getBreachBannerConfig(variant)
    const topBannerText = bannerLayout?.topBannerText
    const splitText = topBannerText?.split(" ")

    return (
        <React.Fragment>
            <StyledABTestBannerWrap breachStyle={style}>
                <StyledMessage breachStyle={style}>
                    {style === 'vanishing-cousins' && typeof(splitText) !== 'undefined' ? (
                        <p>
                            {splitText.shift()}
                            <b> {splitText.shift()} </b>
                            {splitText.join(' ')}
                        </p>
                    ) : (
                        <p>{topBannerText}</p>
                    )}
                    <StyledTitle>{bannerLayout?.mainBannerText}</StyledTitle>
                    <p className="full-width">
                        {bannerLayout?.subBannerText}
                    </p>
                    {style !== 'vanishing-cousins' && (
                        <p className="abtest-terms">
                            {bannerLayout?.tncBannerText}
                        </p>
                    )}
                </StyledMessage>
            </StyledABTestBannerWrap>
        </React.Fragment>
    )
}
